// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {
    width: 100%;
    box-sizing: border-box;

    input[type="radio"] {
        width: 16px !important;
        height: 16px !important;
        padding: 0 !important;
        margin: 0 !important;
        accent-color: #0d6efd;
        cursor: pointer;
        box-shadow: none !important;
    }

    .DemandElement {
        width: 90%;
        max-width: 1500px;
        margin: 0 auto;

        background: #ffffff;
        border: 1px solid #e1e5ea;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-radius: 6px;

        padding: 22px 35px;
        box-sizing: border-box;

        label {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
            line-height: 33px;
        }

        .elements {
            margin: 14px 0;

            .part1 {
                font-size: 13px;
                border: 1px solid #d5dbe1;
                border-radius: 4px;
            }
        }

        textarea,
        select,
        input {
            width: 100%;
            height: 34px;

            border: 1px solid #bfc5cc;
            border-radius: 4px;

            padding: 6px 10px;

            font-family: "Inter", sans-serif;
            font-size: 13px;
            font-weight: 400;
            color: #333333;

            background-color: #ffffff;

            box-sizing: border-box;

            outline: none;

            transition:
                border-color 0.2s ease,
                box-shadow 0.2s ease;
        }

        textarea {
            height: 90px;
            resize: vertical;
        }

        input:focus,
        select:focus,
        textarea:focus {
            border-color: #2c78db;
            box-shadow: 0 0 0 2px rgba(44, 120, 219, 0.10);
        }

        input:read-only {
            background-color: #f7f8fa;
            color: #555555;
            cursor: default;
        }

        select {
            font-size: 13px !important;
            font-weight: 400 !important;
            color: #555555;
        }

        select:focus {
            color: #222222;
        }

        ::placeholder {
            color: #8a8f98;
            font-size: 13px;
        }
    }

    /* =========================
       TABLE
       ========================= */

    .tableContainer {
        width: 100%;
        overflow-x: auto;
        box-sizing: border-box;

        table {
            width: 100%;
            min-width: 850px;

            border-collapse: collapse;
            border-spacing: 0;

            border: 1px solid #d6dce2;

            font-family: "Inter", sans-serif;
            font-size: 13px;

            tr,
            th,
            td {
                padding: 9px 10px;
                box-sizing: border-box;
            }

            th,
            td {
                border: 1px solid #d6dce2 !important;
                font-size: 13px;
                line-height: 1.4;
                vertical-align: middle;
            }

            /* =========================
               TABLE HEADER
               ========================= */

            thead {
                tr {
                    background-color: #eef5fd !important;
                    color: #222222 !important;

                    th {
                        background-color: #eef5fd !important;

                        color: #222222 !important;

                        font-size: 13px !important;
                        font-weight: 600 !important;

                        text-align: left;
                        white-space: nowrap;

                        padding: 10px 10px;

                        border: 1px solid #cbd5df !important;
                    }
                }
            }

            /* =========================
               TABLE BODY
               ========================= */

            tbody {
                tr {
                    background-color: #ffffff;

                    border: 1px solid #d6dce2 !important;

                    transition: background-color 0.15s ease;

                    &:nth-child(even) {
                        background-color: #f8fafc;
                    }

                    &:hover {
                        background-color: #f1f6fb;
                    }

                    td {
                        border: 1px solid #d6dce2 !important;

                        font-size: 13px !important;
                        font-weight: 400 !important;

                        color: #333333;

                        padding: 9px 10px;

                        white-space: normal;
                        word-break: break-word;
                    }
                }
            }
        }
    }
}


/* =========================
   REACT SELECT
   ========================= */

.budgetContainer {
    .css-13cymwt-control,
    .css-t3ipsp-control {
        min-height: 34px !important;
        height: 34px !important;

        border: 1px solid #bfc5cc !important;
        border-radius: 4px !important;

        box-shadow: none !important;

        font-size: 13px !important;
    }

    .css-t3ipsp-control {
        border-color: #2c78db !important;
        box-shadow: 0 0 0 2px rgba(44, 120, 219, 0.10) !important;
    }

    .css-1dimb5e-singleValue,
    .css-1wa3eo5-placeholder {
        font-size: 13px !important;
    }

    .css-1nmdiq5-menu {
        font-size: 13px !important;
        z-index: 9999;
    }

    .css-1n6sfyn-MenuList {
        padding: 4px !important;
    }
}


/* =========================
   RESPONSIVE
   ========================= */

@media (max-width: 1200px) {
    .budgetContainer {
        .DemandElement {
            width: 94%;
            padding: 20px 25px;
        }

        .tableContainer {
            table {
                font-size: 12px;

                th,
                td {
                    font-size: 12px !important;
                    padding: 8px;
                }
            }
        }
    }
}


@media (max-width: 768px) {
    .budgetContainer {
        .DemandElement {
            width: 100%;
            padding: 16px;
        }

        .elements {
            margin: 10px 0;
        }

        label {
            font-size: 13px !important;
        }

        input,
        select,
        textarea {
            font-size: 13px !important;
        }

        .tableContainer {
            table {
                min-width: 750px;

                th,
                td {
                    font-size: 12px !important;
                    padding: 7px 8px;
                }
            }
        }
    }
}
.DemandElement [class*="-control"] input,
.DemandElement [class*="-container"] input {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  height: auto !important;
  min-height: 0 !important;
  width: 100% !important;
}
.field-error {
  color: red;
  font-size: 13px;
  margin: 4px 0 0;
  font-weight: 500;
}


/* 28-10 for new UI */
/* =========================================================
   BILL GENERATION: design match  (labels 14px, rest 12px)
========================================================= */

/* ---------- Header ---------- */
.dg-header {
  width: 90%; max-width: 1500px; margin: 0 auto -33px;
  display: flex; align-items: center; justify-content: space-between;
}
.dg-title { display: flex; align-items: center; gap: 8px; }
.dg-title img { width: 22px; height: 22px; }
.dg-title h3 { margin: 0; font-size: 18px; font-weight: 700; color: #111; }
.dg-back {
  height: 28px; padding: 0 14px; border: none; border-radius: 6px;
  background: linear-gradient(90deg, #f26b3a, #f7a21b);
  color: #fff; font-size: 12px; font-weight: 600; cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
}

/* ---------- White card + grey panel ---------- */
.budgetContainer .DemandElement {
  background: #fff !important;
  border: none !important;
  border-radius: 18px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .18);
  padding: 16px 18px !important;
}
.budgetContainer .DemandElement .dg-panel {
  background: #eef1f6;
  border-radius: 14px;
  padding: 22px 30px 28px;
}

/* ---------- Labels 14px ---------- */
.budgetContainer .DemandElement .dg-panel label {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #1f2430;
  line-height: 38px;
}
.budgetContainer .DemandElement .dg-panel label.ms-1 {   /* Yes / No */
  font-size: 12px !important; font-weight: 600 !important; line-height: 1;
}

/* ---------- Inputs 12px ---------- */
.budgetContainer .DemandElement .dg-panel input:not([type="radio"]):not([type="file"]),
.budgetContainer .DemandElement .dg-panel select,
.budgetContainer .DemandElement .dg-panel textarea {
  height: 38px;
  font-size: 12px;
  border: 1px solid #d3d9e5;
  border-radius: 6px;
  background: #fff;
  padding: 0 12px;
}
.budgetContainer .DemandElement .dg-panel input:focus {
  border-color: #2c78db;
  box-shadow: 0 0 0 2px rgba(44, 120, 219, .12);
}
.budgetContainer .DemandElement .dg-panel ::placeholder { font-size: 12px; color: #8a8f98; }

/* File input */
.budgetContainer .DemandElement .dg-panel input[type="file"] {
  height: 38px; font-size: 12px; padding: 8px 8px; padding-left: 20px;
  border: 1px solid #d3d9e5; border-radius: 6px; background: #fff;
}
.dg-panel input[type="file"]::file-selector-button {
  height: 26px; padding: 0 10px; margin-right: 10px;
  border: 1px solid #bfc5cc; border-radius: 4px;
  background: #f3f4f6; font-size: 12px; cursor: pointer;
}

/* react-select */
.dg-panel [class*="-control"] {
  border-radius: 6px !important;
  border-color: #d3d9e5 !important;
  background: #fff !important;
}
.dg-panel [class*="-singleValue"],
.dg-panel [class*="-placeholder"],
.dg-panel [class*="-option"] { font-size: 12px !important; }

/* ---------- Tables: white card + blue header ---------- */
.budgetContainer .dg-panel .tableContainer {
  background: #fff;
  padding: 16px 18px;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
}
.budgetContainer .dg-panel .tableContainer table {
  min-width: 0;
  border-collapse: separate;
  border-spacing: 0;
  border: 1.5px solid #a9cdf5 !important;
  border-radius: 8px;
  overflow: hidden;
}
.budgetContainer .dg-panel .tableContainer table thead th {
  background: #2f7bd9 !important;
  color: #fff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 9px 8px;
  border: 0 !important;
  border-right: 1px solid rgba(255, 255, 255, .45) !important;
}
.budgetContainer .dg-panel .tableContainer table thead th:last-child { border-right: 0 !important; }
.budgetContainer .dg-panel .tableContainer table tbody td {
  font-size: 12px !important;
  font-weight: 500 !important;
  text-align: center !important;
  padding: 9px 8px;
  color: #111;
  border: 0 !important;
  border-right: 1px solid #b7d6f4 !important;
  border-bottom: 1px solid #b7d6f4 !important;
}
.budgetContainer .dg-panel .tableContainer table tbody td:last-child { border-right: 0 !important; }
.budgetContainer .dg-panel .tableContainer table tbody tr:last-child td { border-bottom: 0 !important; }
.budgetContainer .dg-panel .tableContainer table tbody tr:nth-child(odd)  { background: #e6f3fc; }
.budgetContainer .dg-panel .tableContainer table tbody tr:nth-child(even) { background: #cfe4f2; }

/* Action cell + mini buttons */
.dg-actions-cell { display: table-cell; }
.dg-actions-cell .dg-mini + .dg-mini { margin-left: 8px; }
.dg-mini {
  height: 24px; padding: 0 12px; border-radius: 5px;
  font-size: 12px; font-weight: 600; cursor: pointer;
}
.dg-edit   { background: #eef5fd; color: #2f7bd9; border: 1px solid #2f7bd9; }
.dg-delete { background: #fdeeee; color: #e11d23; border: 1px solid #e11d23; }

/* ---------- Summary bar ---------- */
.dg-summary {
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  background: #cfe4f2; border-radius: 6px; padding: 12px 16px; margin: 16px 0;
  font-size: 12px;
}
.dg-summary > div { display: flex; align-items: center; gap: 24px; flex: 1 1; justify-content: space-between; }
.dg-summary span { font-weight: 600; color: #222; }
.dg-summary b { font-weight: 700; color: #111; }

/* ---------- Deduction section (no inner box) ---------- */
.dg-panel .deduction-section {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
}

/* ---------- Buttons ---------- */
.dg-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  height: 34px; padding: 0 20px; border-radius: 20px;
  font-size: 12px; font-weight: 700; cursor: pointer;
  border: 1.5px solid transparent;
  box-shadow: 0 2px 5px rgba(0, 0, 0, .18);
}
.dg-btn:disabled { cursor: not-allowed; opacity: .8; }

.dg-deduction-actions {
  display: flex; justify-content: center; align-items: center; gap: 14px;
  margin: 20px 0 24px;
}
.dg-btn-add     { background: #0e2f5a; color: #fff; }
.dg-btn-outline { background: #fff; color: #1a6fc4; border-color: #1a6fc4; }

.dg-footer-btns { display: flex; justify-content: center; gap: 18px; margin-top: 28px; }
.dg-btn-save    { background: #2e9e4f; color: #fff; min-width: 110px; height: 36px; }
.dg-btn-cancel  { background: #ef9a94; color: #fff; min-width: 110px; height: 36px; }
.dg-btn-cancel:hover { background: #dc2616; }

/* Spinner (your inline \\3c style> inside the component is never rendered) */
.dg-spin {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, .4); border-top-color: #fff;
  animation: buttonSpin .7s linear infinite;
}
@keyframes buttonSpin { to { transform: rotate(360deg); } }

/* ---------- Responsive ---------- */
@media (max-width: 768px) {
  .budgetContainer .DemandElement .dg-panel { padding: 14px; }
  .dg-summary { flex-direction: column; align-items: stretch; }
  .budgetContainer .dg-panel .tableContainer { overflow-x: auto; }
  .budgetContainer .dg-panel .tableContainer table { min-width: 700px; }
}
/* Smaller table corners */
.budgetContainer .dg-panel .tableContainer table {
  border-radius: 6px !important;
}

/* Keep Edit + Delete on one line */
.budgetContainer .dg-panel .tableContainer table tbody td.dg-actions-cell {
  white-space: nowrap;
  word-break: normal;
  min-width: 150px;
}
.dg-actions-cell .dg-mini {
  display: inline-block;
  vertical-align: middle;
}

/* Smaller, less rounded buttons */
.dg-mini {
  height: 24px;
  padding: 0 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/DemandManagement/DemandGeneration/DemandGenral.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;;IAEtB;QACI,sBAAsB;QACtB,uBAAuB;QACvB,qBAAqB;QACrB,oBAAoB;QACpB,qBAAqB;QACrB,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,cAAc;;QAEd,mBAAmB;QACnB,yBAAyB;QACzB,yCAAyC;QACzC,kBAAkB;;QAElB,kBAAkB;QAClB,sBAAsB;;QAEtB;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,iBAAiB;QACrB;;QAEA;YACI,cAAc;;YAEd;gBACI,eAAe;gBACf,yBAAyB;gBACzB,kBAAkB;YACtB;QACJ;;QAEA;;;YAGI,WAAW;YACX,YAAY;;YAEZ,yBAAyB;YACzB,kBAAkB;;YAElB,iBAAiB;;YAEjB,gCAAgC;YAChC,eAAe;YACf,gBAAgB;YAChB,cAAc;;YAEd,yBAAyB;;YAEzB,sBAAsB;;YAEtB,aAAa;;YAEb;;oCAEwB;QAC5B;;QAEA;YACI,YAAY;YACZ,gBAAgB;QACpB;;QAEA;;;YAGI,qBAAqB;YACrB,8CAA8C;QAClD;;QAEA;YACI,yBAAyB;YACzB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,eAAe;QACnB;IACJ;;IAEA;;kCAE8B;;IAE9B;QACI,WAAW;QACX,gBAAgB;QAChB,sBAAsB;;QAEtB;YACI,WAAW;YACX,gBAAgB;;YAEhB,yBAAyB;YACzB,iBAAiB;;YAEjB,yBAAyB;;YAEzB,gCAAgC;YAChC,eAAe;;YAEf;;;gBAGI,iBAAiB;gBACjB,sBAAsB;YAC1B;;YAEA;;gBAEI,oCAAoC;gBACpC,eAAe;gBACf,gBAAgB;gBAChB,sBAAsB;YAC1B;;YAEA;;0CAE8B;;YAE9B;gBACI;oBACI,oCAAoC;oBACpC,yBAAyB;;oBAEzB;wBACI,oCAAoC;;wBAEpC,yBAAyB;;wBAEzB,0BAA0B;wBAC1B,2BAA2B;;wBAE3B,gBAAgB;wBAChB,mBAAmB;;wBAEnB,kBAAkB;;wBAElB,oCAAoC;oBACxC;gBACJ;YACJ;;YAEA;;0CAE8B;;YAE9B;gBACI;oBACI,yBAAyB;;oBAEzB,oCAAoC;;oBAEpC,uCAAuC;;oBAEvC;wBACI,yBAAyB;oBAC7B;;oBAEA;wBACI,yBAAyB;oBAC7B;;oBAEA;wBACI,oCAAoC;;wBAEpC,0BAA0B;wBAC1B,2BAA2B;;wBAE3B,cAAc;;wBAEd,iBAAiB;;wBAEjB,mBAAmB;wBACnB,sBAAsB;oBAC1B;gBACJ;YACJ;QACJ;IACJ;AACJ;;;AAGA;;8BAE8B;;AAE9B;IACI;;QAEI,2BAA2B;QAC3B,uBAAuB;;QAEvB,oCAAoC;QACpC,6BAA6B;;QAE7B,2BAA2B;;QAE3B,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;QAChC,yDAAyD;IAC7D;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;;AAGA;;8BAE8B;;AAE9B;IACI;QACI;YACI,UAAU;YACV,kBAAkB;QACtB;;QAEA;YACI;gBACI,eAAe;;gBAEf;;oBAEI,0BAA0B;oBAC1B,YAAY;gBAChB;YACJ;QACJ;IACJ;AACJ;;;AAGA;IACI;QACI;YACI,WAAW;YACX,aAAa;QACjB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,0BAA0B;QAC9B;;QAEA;;;YAGI,0BAA0B;QAC9B;;QAEA;YACI;gBACI,gBAAgB;;gBAEhB;;oBAEI,0BAA0B;oBAC1B,gBAAgB;gBACpB;YACJ;QACJ;IACJ;AACJ;AACA;;EAEE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;;AAGA,qBAAqB;AACrB;;2DAE2D;;AAE3D,iCAAiC;AACjC;EACE,UAAU,EAAE,iBAAiB,EAAE,oBAAoB;EACnD,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;AACpE;AACA,YAAY,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC1D,gBAAgB,WAAW,EAAE,YAAY,EAAE;AAC3C,eAAe,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAC1E;EACE,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB;EAC/D,oDAAoD;EACpD,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe;EAC/D,uCAAuC;AACzC;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;AACA,yDAAyD,aAAa;EACpE,0BAA0B,EAAE,2BAA2B,EAAE,cAAc;AACzE;;AAEA,sCAAsC;AACtC;;;EAGE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,0DAA0D,eAAe,EAAE,cAAc,EAAE;;AAE3F,eAAe;AACf;EACE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB;EACnE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB;AACjE;AACA;EACE,YAAY,EAAE,eAAe,EAAE,kBAAkB;EACjD,yBAAyB,EAAE,kBAAkB;EAC7C,mBAAmB,EAAE,eAAe,EAAE,eAAe;AACvD;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;;+BAE+B,0BAA0B,EAAE;;AAE3D,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,2DAA2D;AAC7D;AACA,uEAAuE,0BAA0B,EAAE;AACnG;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA,uEAAuE,0BAA0B,EAAE;AACnG,0EAA0E,2BAA2B,EAAE;AACvG,4EAA4E,mBAAmB,EAAE;AACjG,4EAA4E,mBAAmB,EAAE;;AAEjG,+BAA+B;AAC/B,mBAAmB,mBAAmB,EAAE;AACxC,uCAAuC,gBAAgB,EAAE;AACzD;EACE,YAAY,EAAE,eAAe,EAAE,kBAAkB;EACjD,eAAe,EAAE,gBAAgB,EAAE,eAAe;AACpD;AACA,aAAa,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC7E,aAAa,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE7E,sCAAsC;AACtC;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,cAAc;EAC3E,eAAe;AACjB;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,SAAO,EAAE,8BAA8B,EAAE;AAC5G,mBAAmB,gBAAgB,EAAE,WAAW,EAAE;AAClD,gBAAgB,gBAAgB,EAAE,WAAW,EAAE;;AAE/C,2DAA2D;AAC3D;EACE,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;EAC5E,YAAY,EAAE,eAAe,EAAE,mBAAmB;EAClD,eAAe,EAAE,gBAAgB,EAAE,eAAe;EAClD,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA,mBAAmB,mBAAmB,EAAE,WAAW,EAAE;;AAErD;EACE,aAAa,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,SAAS;EACtE,mBAAmB;AACrB;AACA,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;AACpD,kBAAkB,gBAAgB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE3E,kBAAkB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACvF,kBAAkB,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACpF,kBAAkB,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACpF,uBAAuB,mBAAmB,EAAE;;AAE5C,4EAAyE;AACzE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,yCAAyC,EAAE,sBAAsB;EACjE,yCAAyC;AAC3C;AACA,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;;AAE1D,qCAAqC;AACrC;EACE,4CAA4C,aAAa,EAAE;EAC3D,cAAc,sBAAsB,EAAE,oBAAoB,EAAE;EAC5D,6CAA6C,gBAAgB,EAAE;EAC/D,mDAAmD,gBAAgB,EAAE;AACvE;AACA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".budgetContainer {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    input[type=\"radio\"] {\r\n        width: 16px !important;\r\n        height: 16px !important;\r\n        padding: 0 !important;\r\n        margin: 0 !important;\r\n        accent-color: #0d6efd;\r\n        cursor: pointer;\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    .DemandElement {\r\n        width: 90%;\r\n        max-width: 1500px;\r\n        margin: 0 auto;\r\n\r\n        background: #ffffff;\r\n        border: 1px solid #e1e5ea;\r\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n        border-radius: 6px;\r\n\r\n        padding: 22px 35px;\r\n        box-sizing: border-box;\r\n\r\n        label {\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            color: #333333;\r\n            line-height: 33px;\r\n        }\r\n\r\n        .elements {\r\n            margin: 14px 0;\r\n\r\n            .part1 {\r\n                font-size: 13px;\r\n                border: 1px solid #d5dbe1;\r\n                border-radius: 4px;\r\n            }\r\n        }\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            height: 34px;\r\n\r\n            border: 1px solid #bfc5cc;\r\n            border-radius: 4px;\r\n\r\n            padding: 6px 10px;\r\n\r\n            font-family: \"Inter\", sans-serif;\r\n            font-size: 13px;\r\n            font-weight: 400;\r\n            color: #333333;\r\n\r\n            background-color: #ffffff;\r\n\r\n            box-sizing: border-box;\r\n\r\n            outline: none;\r\n\r\n            transition:\r\n                border-color 0.2s ease,\r\n                box-shadow 0.2s ease;\r\n        }\r\n\r\n        textarea {\r\n            height: 90px;\r\n            resize: vertical;\r\n        }\r\n\r\n        input:focus,\r\n        select:focus,\r\n        textarea:focus {\r\n            border-color: #2c78db;\r\n            box-shadow: 0 0 0 2px rgba(44, 120, 219, 0.10);\r\n        }\r\n\r\n        input:read-only {\r\n            background-color: #f7f8fa;\r\n            color: #555555;\r\n            cursor: default;\r\n        }\r\n\r\n        select {\r\n            font-size: 13px !important;\r\n            font-weight: 400 !important;\r\n            color: #555555;\r\n        }\r\n\r\n        select:focus {\r\n            color: #222222;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #8a8f98;\r\n            font-size: 13px;\r\n        }\r\n    }\r\n\r\n    /* =========================\r\n       TABLE\r\n       ========================= */\r\n\r\n    .tableContainer {\r\n        width: 100%;\r\n        overflow-x: auto;\r\n        box-sizing: border-box;\r\n\r\n        table {\r\n            width: 100%;\r\n            min-width: 850px;\r\n\r\n            border-collapse: collapse;\r\n            border-spacing: 0;\r\n\r\n            border: 1px solid #d6dce2;\r\n\r\n            font-family: \"Inter\", sans-serif;\r\n            font-size: 13px;\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                padding: 9px 10px;\r\n                box-sizing: border-box;\r\n            }\r\n\r\n            th,\r\n            td {\r\n                border: 1px solid #d6dce2 !important;\r\n                font-size: 13px;\r\n                line-height: 1.4;\r\n                vertical-align: middle;\r\n            }\r\n\r\n            /* =========================\r\n               TABLE HEADER\r\n               ========================= */\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #eef5fd !important;\r\n                    color: #222222 !important;\r\n\r\n                    th {\r\n                        background-color: #eef5fd !important;\r\n\r\n                        color: #222222 !important;\r\n\r\n                        font-size: 13px !important;\r\n                        font-weight: 600 !important;\r\n\r\n                        text-align: left;\r\n                        white-space: nowrap;\r\n\r\n                        padding: 10px 10px;\r\n\r\n                        border: 1px solid #cbd5df !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            /* =========================\r\n               TABLE BODY\r\n               ========================= */\r\n\r\n            tbody {\r\n                tr {\r\n                    background-color: #ffffff;\r\n\r\n                    border: 1px solid #d6dce2 !important;\r\n\r\n                    transition: background-color 0.15s ease;\r\n\r\n                    &:nth-child(even) {\r\n                        background-color: #f8fafc;\r\n                    }\r\n\r\n                    &:hover {\r\n                        background-color: #f1f6fb;\r\n                    }\r\n\r\n                    td {\r\n                        border: 1px solid #d6dce2 !important;\r\n\r\n                        font-size: 13px !important;\r\n                        font-weight: 400 !important;\r\n\r\n                        color: #333333;\r\n\r\n                        padding: 9px 10px;\r\n\r\n                        white-space: normal;\r\n                        word-break: break-word;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* =========================\r\n   REACT SELECT\r\n   ========================= */\r\n\r\n.budgetContainer {\r\n    .css-13cymwt-control,\r\n    .css-t3ipsp-control {\r\n        min-height: 34px !important;\r\n        height: 34px !important;\r\n\r\n        border: 1px solid #bfc5cc !important;\r\n        border-radius: 4px !important;\r\n\r\n        box-shadow: none !important;\r\n\r\n        font-size: 13px !important;\r\n    }\r\n\r\n    .css-t3ipsp-control {\r\n        border-color: #2c78db !important;\r\n        box-shadow: 0 0 0 2px rgba(44, 120, 219, 0.10) !important;\r\n    }\r\n\r\n    .css-1dimb5e-singleValue,\r\n    .css-1wa3eo5-placeholder {\r\n        font-size: 13px !important;\r\n    }\r\n\r\n    .css-1nmdiq5-menu {\r\n        font-size: 13px !important;\r\n        z-index: 9999;\r\n    }\r\n\r\n    .css-1n6sfyn-MenuList {\r\n        padding: 4px !important;\r\n    }\r\n}\r\n\r\n\r\n/* =========================\r\n   RESPONSIVE\r\n   ========================= */\r\n\r\n@media (max-width: 1200px) {\r\n    .budgetContainer {\r\n        .DemandElement {\r\n            width: 94%;\r\n            padding: 20px 25px;\r\n        }\r\n\r\n        .tableContainer {\r\n            table {\r\n                font-size: 12px;\r\n\r\n                th,\r\n                td {\r\n                    font-size: 12px !important;\r\n                    padding: 8px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .budgetContainer {\r\n        .DemandElement {\r\n            width: 100%;\r\n            padding: 16px;\r\n        }\r\n\r\n        .elements {\r\n            margin: 10px 0;\r\n        }\r\n\r\n        label {\r\n            font-size: 13px !important;\r\n        }\r\n\r\n        input,\r\n        select,\r\n        textarea {\r\n            font-size: 13px !important;\r\n        }\r\n\r\n        .tableContainer {\r\n            table {\r\n                min-width: 750px;\r\n\r\n                th,\r\n                td {\r\n                    font-size: 12px !important;\r\n                    padding: 7px 8px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.DemandElement [class*=\"-control\"] input,\r\n.DemandElement [class*=\"-container\"] input {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n  height: auto !important;\r\n  min-height: 0 !important;\r\n  width: 100% !important;\r\n}\r\n.field-error {\r\n  color: red;\r\n  font-size: 13px;\r\n  margin: 4px 0 0;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n/* 28-10 for new UI */\r\n/* =========================================================\r\n   BILL GENERATION: design match  (labels 14px, rest 12px)\r\n========================================================= */\r\n\r\n/* ---------- Header ---------- */\r\n.dg-header {\r\n  width: 90%; max-width: 1500px; margin: 0 auto -33px;\r\n  display: flex; align-items: center; justify-content: space-between;\r\n}\r\n.dg-title { display: flex; align-items: center; gap: 8px; }\r\n.dg-title img { width: 22px; height: 22px; }\r\n.dg-title h3 { margin: 0; font-size: 18px; font-weight: 700; color: #111; }\r\n.dg-back {\r\n  height: 28px; padding: 0 14px; border: none; border-radius: 6px;\r\n  background: linear-gradient(90deg, #f26b3a, #f7a21b);\r\n  color: #fff; font-size: 12px; font-weight: 600; cursor: pointer;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, .2);\r\n}\r\n\r\n/* ---------- White card + grey panel ---------- */\r\n.budgetContainer .DemandElement {\r\n  background: #fff !important;\r\n  border: none !important;\r\n  border-radius: 18px;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, .18);\r\n  padding: 16px 18px !important;\r\n}\r\n.budgetContainer .DemandElement .dg-panel {\r\n  background: #eef1f6;\r\n  border-radius: 14px;\r\n  padding: 22px 30px 28px;\r\n}\r\n\r\n/* ---------- Labels 14px ---------- */\r\n.budgetContainer .DemandElement .dg-panel label {\r\n  font-size: 14px !important;\r\n  font-weight: 700 !important;\r\n  color: #1f2430;\r\n  line-height: 38px;\r\n}\r\n.budgetContainer .DemandElement .dg-panel label.ms-1 {   /* Yes / No */\r\n  font-size: 12px !important; font-weight: 600 !important; line-height: 1;\r\n}\r\n\r\n/* ---------- Inputs 12px ---------- */\r\n.budgetContainer .DemandElement .dg-panel input:not([type=\"radio\"]):not([type=\"file\"]),\r\n.budgetContainer .DemandElement .dg-panel select,\r\n.budgetContainer .DemandElement .dg-panel textarea {\r\n  height: 38px;\r\n  font-size: 12px;\r\n  border: 1px solid #d3d9e5;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  padding: 0 12px;\r\n}\r\n.budgetContainer .DemandElement .dg-panel input:focus {\r\n  border-color: #2c78db;\r\n  box-shadow: 0 0 0 2px rgba(44, 120, 219, .12);\r\n}\r\n.budgetContainer .DemandElement .dg-panel ::placeholder { font-size: 12px; color: #8a8f98; }\r\n\r\n/* File input */\r\n.budgetContainer .DemandElement .dg-panel input[type=\"file\"] {\r\n  height: 38px; font-size: 12px; padding: 8px 8px; padding-left: 20px;\r\n  border: 1px solid #d3d9e5; border-radius: 6px; background: #fff;\r\n}\r\n.dg-panel input[type=\"file\"]::file-selector-button {\r\n  height: 26px; padding: 0 10px; margin-right: 10px;\r\n  border: 1px solid #bfc5cc; border-radius: 4px;\r\n  background: #f3f4f6; font-size: 12px; cursor: pointer;\r\n}\r\n\r\n/* react-select */\r\n.dg-panel [class*=\"-control\"] {\r\n  border-radius: 6px !important;\r\n  border-color: #d3d9e5 !important;\r\n  background: #fff !important;\r\n}\r\n.dg-panel [class*=\"-singleValue\"],\r\n.dg-panel [class*=\"-placeholder\"],\r\n.dg-panel [class*=\"-option\"] { font-size: 12px !important; }\r\n\r\n/* ---------- Tables: white card + blue header ---------- */\r\n.budgetContainer .dg-panel .tableContainer {\r\n  background: #fff;\r\n  padding: 16px 18px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);\r\n}\r\n.budgetContainer .dg-panel .tableContainer table {\r\n  min-width: 0;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  border: 1.5px solid #a9cdf5 !important;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n.budgetContainer .dg-panel .tableContainer table thead th {\r\n  background: #2f7bd9 !important;\r\n  color: #fff !important;\r\n  font-size: 12px !important;\r\n  font-weight: 600 !important;\r\n  text-align: center !important;\r\n  padding: 9px 8px;\r\n  border: 0 !important;\r\n  border-right: 1px solid rgba(255, 255, 255, .45) !important;\r\n}\r\n.budgetContainer .dg-panel .tableContainer table thead th:last-child { border-right: 0 !important; }\r\n.budgetContainer .dg-panel .tableContainer table tbody td {\r\n  font-size: 12px !important;\r\n  font-weight: 500 !important;\r\n  text-align: center !important;\r\n  padding: 9px 8px;\r\n  color: #111;\r\n  border: 0 !important;\r\n  border-right: 1px solid #b7d6f4 !important;\r\n  border-bottom: 1px solid #b7d6f4 !important;\r\n}\r\n.budgetContainer .dg-panel .tableContainer table tbody td:last-child { border-right: 0 !important; }\r\n.budgetContainer .dg-panel .tableContainer table tbody tr:last-child td { border-bottom: 0 !important; }\r\n.budgetContainer .dg-panel .tableContainer table tbody tr:nth-child(odd)  { background: #e6f3fc; }\r\n.budgetContainer .dg-panel .tableContainer table tbody tr:nth-child(even) { background: #cfe4f2; }\r\n\r\n/* Action cell + mini buttons */\r\n.dg-actions-cell { display: table-cell; }\r\n.dg-actions-cell .dg-mini + .dg-mini { margin-left: 8px; }\r\n.dg-mini {\r\n  height: 24px; padding: 0 12px; border-radius: 5px;\r\n  font-size: 12px; font-weight: 600; cursor: pointer;\r\n}\r\n.dg-edit   { background: #eef5fd; color: #2f7bd9; border: 1px solid #2f7bd9; }\r\n.dg-delete { background: #fdeeee; color: #e11d23; border: 1px solid #e11d23; }\r\n\r\n/* ---------- Summary bar ---------- */\r\n.dg-summary {\r\n  display: flex; align-items: center; justify-content: space-between; gap: 16px;\r\n  background: #cfe4f2; border-radius: 6px; padding: 12px 16px; margin: 16px 0;\r\n  font-size: 12px;\r\n}\r\n.dg-summary > div { display: flex; align-items: center; gap: 24px; flex: 1; justify-content: space-between; }\r\n.dg-summary span { font-weight: 600; color: #222; }\r\n.dg-summary b { font-weight: 700; color: #111; }\r\n\r\n/* ---------- Deduction section (no inner box) ---------- */\r\n.dg-panel .deduction-section {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n/* ---------- Buttons ---------- */\r\n.dg-btn {\r\n  display: inline-flex; align-items: center; justify-content: center; gap: 8px;\r\n  height: 34px; padding: 0 20px; border-radius: 20px;\r\n  font-size: 12px; font-weight: 700; cursor: pointer;\r\n  border: 1.5px solid transparent;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, .18);\r\n}\r\n.dg-btn:disabled { cursor: not-allowed; opacity: .8; }\r\n\r\n.dg-deduction-actions {\r\n  display: flex; justify-content: center; align-items: center; gap: 14px;\r\n  margin: 20px 0 24px;\r\n}\r\n.dg-btn-add     { background: #0e2f5a; color: #fff; }\r\n.dg-btn-outline { background: #fff; color: #1a6fc4; border-color: #1a6fc4; }\r\n\r\n.dg-footer-btns { display: flex; justify-content: center; gap: 18px; margin-top: 28px; }\r\n.dg-btn-save    { background: #2e9e4f; color: #fff; min-width: 110px; height: 36px; }\r\n.dg-btn-cancel  { background: #ef9a94; color: #fff; min-width: 110px; height: 36px; }\r\n.dg-btn-cancel:hover { background: #dc2616; }\r\n\r\n/* Spinner (your inline <style> inside the component is never rendered) */\r\n.dg-spin {\r\n  width: 14px; height: 14px; border-radius: 50%;\r\n  border: 2px solid rgba(255, 255, 255, .4); border-top-color: #fff;\r\n  animation: buttonSpin .7s linear infinite;\r\n}\r\n@keyframes buttonSpin { to { transform: rotate(360deg); } }\r\n\r\n/* ---------- Responsive ---------- */\r\n@media (max-width: 768px) {\r\n  .budgetContainer .DemandElement .dg-panel { padding: 14px; }\r\n  .dg-summary { flex-direction: column; align-items: stretch; }\r\n  .budgetContainer .dg-panel .tableContainer { overflow-x: auto; }\r\n  .budgetContainer .dg-panel .tableContainer table { min-width: 700px; }\r\n}\r\n/* Smaller table corners */\r\n.budgetContainer .dg-panel .tableContainer table {\r\n  border-radius: 6px !important;\r\n}\r\n\r\n/* Keep Edit + Delete on one line */\r\n.budgetContainer .dg-panel .tableContainer table tbody td.dg-actions-cell {\r\n  white-space: nowrap;\r\n  word-break: normal;\r\n  min-width: 150px;\r\n}\r\n.dg-actions-cell .dg-mini {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Smaller, less rounded buttons */\r\n.dg-mini {\r\n  height: 24px;\r\n  padding: 0 12px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
